export interface IFitmentOption {
    optionName: string;
    optionValue: string;
}

export interface IColorData {
    colorId: number;
    colorName: string;
}

export interface IVehicle {
    make: string;
    model: string;
    year: string;
    fitmentOptions: IFitmentOption[];
    colorData?: IColorData;
}

export interface IFitmentTitle {
    name: string;
    title: string;
}

export interface IVehcileDefaultValues {
    defaultMake: string | null,
    defaultModel: string | null,
    defaultYear: string | null,
    displayableMake: string | null,
    displayableModel: string | null,
}

export enum ISecondaryVehicleSelectionOptions {
    TireSizeAndPosition = "vcdb.TireSizeAndPosition",
    WheelSizeAndPosition = "vcdb.WheelSizeAndPosition",
}
